import { selectCurrentTree, selectRehabResultsPagination } from '@Selectors';
import { useAdpAnalytics } from '@innovyze/stylovyze';
import { useEffect, useRef } from 'react';

export function useTrackRehabResultsView(treeId: string): void {
	const adp = useAdpAnalytics();
	const currentTree = selectCurrentTree();
	const rehabResultsPagination = selectRehabResultsPagination();
	const hasTrackedResultsTabRef = useRef(false);

	useEffect(() => {
		if (
			!adp ||
			(rehabResultsPagination.total ?? 0) <= 0 ||
			hasTrackedResultsTabRef.current
		) {
			return;
		}

		try {
			adp.track('USER_VIEW', {
				id: 'rehab-results-tab',
				type: 'page-view',
				name: 'User accessed rehab results',
				attributes: {
					treeId,
					name: currentTree?.name ?? '',
					systemtype: currentTree?.systemType?.id ?? '',
					inspectionstandard: currentTree?.inspectionStandard ?? '',
					assettype: currentTree?.assetType?.id ?? '',
					resultcount: String(rehabResultsPagination.total ?? 0),
				},
			});

			hasTrackedResultsTabRef.current = true;
		} catch (error) {
			console.error('Error tracking rehab results view', error);
		}
	}, [
		adp,
		currentTree?.assetType?.id,
		currentTree?.inspectionStandard,
		currentTree?.name,
		currentTree?.systemType?.id,
		rehabResultsPagination.total,
		treeId,
	]);
}
